import React from 'react';
import ChevronRight from '@material-ui/icons/ChevronRight'

const Breadcrumb = ({name, url, icon, history}) => {
	// We use history.push inside framework code because Router context breaks with duplicate instances of react-router-dom
	const handleClick = (e) => {
		e.preventDefault();
		history.push(url);
	}

	return (
		<li>
			<a href={url} onClick={handleClick}>
				<i className={`fa fa-${icon}`}/>
				<span>{name}</span>
				<ChevronRight fontSize={'small'}/>
			</a>
		</li>
	);
}

export default Breadcrumb;
